import { AnimatePresence, motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import ClosingXsvg from './images/images-header/ClosingXsvg';
import { useState } from 'react';
import HomeSVG from './images/images-home/HomeSVG';
import Functionary from './images/images-home/Functionary';
import Food from './images/images-home/Food';
import Health from './images/images-home/Health';
import Seniors from './images/images-home/Seniors';
import MapSVG from './images/images-home/MapSVG';



const Navbar = () => {  
    
    const [hamburger, setHamburger] = useState(true) //When hamburger = true, the navigation bar will be closed
                                                    //When hamburger = false, the navigation bar will be open

    const navigate = useNavigate();

    const changeRoute = (location) => {
        navigate(location);
        setHamburger(true);
        window.scrollTo(0, 0);
    }


    //making a function in which a click on the father's tag closes the navbar (and a click on his children will not close the navbar)
    const closingNavbar = (e) => {
        if (e.target.className !== 'nav-container') {
            return
        } else {
            setHamburger(true)
        }
    }


    // const handleClickOnEmail =() => {
    //     setHamburger(true)
    // }



    return (  
        <>
            <AnimatePresence initial={false}>
            {/* svg of a hamburger */}
                <svg 
                 onClick={() => setHamburger(false)}  
                 initial={{style: {stroke: "#fff"}}} 
                 animate={{style: {stroke: "#85ba84"}}} 
                 transition={{duration: 0}}    
                 className="ionicon" 
                 xmlns="http://www.w3.org/2000/svg" 
                 viewBox="0 0 512 512"
                >
                    <path fill="none" stroke="#fff" stroke-linecap="round" stroke-miterlimit="10" stroke-width="32" d="M80 160h352M80 256h352M80 352h352"/>
                </svg> 
                
            </AnimatePresence>

            
            <AnimatePresence>  {/* AnimatePresence let us use exit in our animation */}
                
                {!hamburger &&

                    <motion.div className="nav-container" onClick={(e) => closingNavbar(e)}
                        // onClick={() => setHamburger(true)}
                        initial={{opacity: 0}} 
                        animate={{opacity: 1}} 
                        exit={{opacity: 0, transition: {duration: 0, delay: 0.4}}}
                        transition={{duration: 0, delay: 0.5, type: "tween", ease: "easeInOut"}} 
                    >

                        <motion.div className="nav-GreenContainer"
                            initial={{x: '100vh'}} 
                            animate={{x: 0}} 
                            exit={{x: '100vh', transition: {duration: 1.5}}}
                            transition={{duration: 1, type: "tween", ease: "easeInOut"}} 
                        >
                        
                            {/* the closing X */}
                            {/* sending a prop to the component: ClosingXsvg, so we will make there a click event
                            that will setHamburger to true on a click */}
                            <div className="closingX2">
                                <ClosingXsvg setHamburger={setHamburger} />  
                            </div>
                        
                            <div className="pageNameAndItsSVG">
                                <p className='pageName'><span onClick={() => changeRoute('/')}>עמוד הבית</span></p>
                                <div className="svg-container" onClick={() => changeRoute('/')}>
                                    <HomeSVG size={"20px"} color={"white"}/>
                                </div>       
                            </div>


                            <p className='pageName'><span onClick={() => changeRoute('/general-info')}>רקע כללי</span></p>
                            

                            <div className="pageNameAndItsSVG">
                                <p className='pageName'><span onClick={() => changeRoute('/functionary')}>בעלי תפקידים</span></p>
                                <div className="svg-container" onClick={() => changeRoute('/functionary')}>
                                    <Functionary size={"22px"} color={"white"} />
                                </div>
                            </div>


                            <p className='pageName'><span onClick={() => changeRoute('/technology')}>טכנולוגיה</span></p>
                            <p className='pageName'><span onClick={() => changeRoute('/facilities')}>מתקני הקיבוץ</span></p>


                            <div className="pageNameAndItsSVG">
                                <p className='pageName'><span onClick={() => changeRoute('/food')}>מזון</span></p>
                                <div className="svg-container" onClick={() => changeRoute('/food')}>
                                    <Food size={"22px"} color={"white"}/>
                                </div>
                            </div>
                            

                            <p className='pageName'><span onClick={() => changeRoute('/education')}>חינוך</span></p>
                            <p className='pageName'><span onClick={() => changeRoute('/culture')}>תרבות</span></p>


                            <div className="pageNameAndItsSVG">
                                <p className='pageName'><span onClick={() => changeRoute('/health')}>בריאות</span></p>
                                <div className="svg-container" onClick={() => changeRoute('/health')}>
                                    <Health size={"22px"} color={"white"}/>
                                </div>
                            </div>
                            

                            <div className="pageNameAndItsSVG">
                                <p className='pageName'><span onClick={() => changeRoute('/seniors')}>ותיקים</span></p>
                                <div className="svg-container" onClick={() => changeRoute('/seniors')}>
                                    <Seniors size={"22px"} color={"white"}/>
                                </div>
                            </div>
                            

                            <p className='pageName'><span onClick={() => changeRoute('/sport')}>ספורט וחוגים</span></p>
                            <p className='pageName'><span onClick={() => changeRoute('/gas-stations')}>תחנות דלק</span></p>
                            

                            <div className="pageNameAndItsSVG">
                                <p className='pageName'><span onClick={() => changeRoute('/map')}>מפת הקיבוץ</span></p>
                                <div className="svg-container" onClick={() => changeRoute('/map')}>
                                    <MapSVG size={"22px"} color={"white"}/>
                                </div>
                            </div>
                            

                            <a href="mailto:michal.diminsky@gmail.com" onClick={() => setHamburger(true)}>יצירת קשר בענייני האתר</a>
                        </motion.div>
                    </motion.div>
          
                }
            </AnimatePresence>
            
        </>
    );
}
 
export default Navbar;